import { fetchHttpClient } from '@service-initiation/shared-clients-fetch-http';
import { ReserveWithGoogleClient } from '@service-initiation/shared-clients-reserve-with-google';

export const reserveWithGoogleClient = new ReserveWithGoogleClient({
  baseUrl: process.env['NX_PUBLIC_RESERVE_WITH_GOOGLE_URL'],
  httpClient: fetchHttpClient,
});
